export class TipoClassificazione{
    id:number;
    tipo:string;
}